import { css } from 'styled-components';
import { BreakpointSmall, BreakpointMedium, BreakpointLarge, BreakpointXlarge, BreakpointXxlarge, BreakpointXxxlarge } from '@dentsu-ui/elements';
var sizes = {
  small: BreakpointSmall,
  medium: BreakpointMedium,
  large: BreakpointLarge,
  xlarge: BreakpointXlarge,
  xxlarge: BreakpointXxlarge,
  xxxlarge: BreakpointXxxlarge
};
export default Object.keys(sizes).reduce(function (acc, label) {
  acc[label] = function () {
    return css(["@media (min-width:", "){", ";}"], sizes[label], css.apply(void 0, arguments));
  };

  return acc;
}, {});